module.exports = __webpack_public_path__ + "static/media/resume-analyzer-1.8f447762.png";